import {
  ColumnDef,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';

import { useDataGridSizingLocalStorage } from '@/components/DataGrid.utils';
import { GridPaginationModel } from '@/hooks/useDataGridState';
import { RuleSchema } from '@/types/schema';

interface Headers {
  'x-pagination-total': number;
}

type RowData = RuleSchema[] & {
  headers?: Headers | undefined;
};

interface UseRulesTableProps {
  rows?: RowData;
  paginationModel: GridPaginationModel;
  onPaginationChange: React.Dispatch<React.SetStateAction<GridPaginationModel>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: ColumnDef<RuleSchema, any>[];
  setDeleteOpen?: React.Dispatch<React.SetStateAction<string | null>>;
}

export const useRulesTable = ({
  rows,
  paginationModel,
  onPaginationChange,
  columns,
  setDeleteOpen,
}: UseRulesTableProps) => {
  'use no memo';
  const EMPTY_TABLE = [];

  const [columnSizing, setColumnSizing] =
    useDataGridSizingLocalStorage('rules');

  return useReactTable({
    columns: columns,
    data: rows ?? EMPTY_TABLE,
    state: {
      pagination: paginationModel,
      columnSizing,
    },
    meta: {
      actions: {
        handleDelete: setDeleteOpen,
      },
    },
    onPaginationChange,
    onColumnSizingChange: setColumnSizing,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    manualExpanding: true,
    manualPagination: true,
    manualFiltering: true,
    manualSorting: true,
    columnResizeMode: 'onChange',
    pageCount: Math.ceil(
      +(rows?.headers?.['x-pagination-total'] || 0) / paginationModel.pageSize
    ),
  });
};
